import { EnvironmentVariableService } from '@portal/shared/helpers/src';

export enum CountLimitAsyncReport {
  AsyncReportLimit = EnvironmentVariableService.getVar('TXNCOUNTLIMIT_ASYNCREPORT') as number,
  SettlementReportRecordsLimits = EnvironmentVariableService.getVar(
    'SETTLEMENT_RECORD_LIMIT_FOR_MODE_CHANGE',
  ) as number, // Modes - Enum: "INSTANT_REPORT" & "ASYNC_REPORT"
}
